export const isSendFreeMessageInAutocompleteDisabled = (autocompleteUri?: string): boolean =>
	!!autocompleteUri?.includes('disableEnter=true');
